import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=1632ca8f&"
import script from "./AdminFooter.vue?vue&type=script&lang=js&"
export * from "./AdminFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports